import { render } from "./CopyActivityModal.vue?vue&type=template&id=ba7e9666&scoped=true"
import script from "./CopyActivityModal.vue?vue&type=script&lang=js"
export * from "./CopyActivityModal.vue?vue&type=script&lang=js"

import "./CopyActivityModal.vue?vue&type=style&index=0&id=ba7e9666&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7e9666"]])

export default __exports__